const env = process.env;
let baseURL;
if (env.NODE_ENV == "development") {
  baseURL = "/api";
} else if (env.NODE_ENV == "test") {
  // 测试
  baseURL = "http://218.94.57.151:8001/dnnWebManage/";
} else if (env.NODE_ENV == "production") {
  // 正式
  baseURL = "/api";
}
console.log("env------------", env, process.env);
const prefix = env.BASE_URL.indexOf("dnnweb") > -1 ? "/dnnweb" : "";
export { baseURL, prefix };
